// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".border-radius[data-v-79da57e8]{border-radius:10px}.hover-text[data-v-79da57e8]:hover,.remove-x-btn[data-v-79da57e8]{cursor:pointer}.remove-x-btn[data-v-79da57e8]{display:inline;position:absolute;right:8px;top:8px}.remove-x-btn i[data-v-79da57e8]{border-radius:50%}.remove-x-btn i[data-v-79da57e8]:hover{border-color:#a2a2a7;box-shadow:.5px .5px .5px .5px #a2a2a7}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
